import { z } from 'zod';

// Define email validation schema
const emailSchema = z.string().email();

/**
 * Validates an email address
 * @param email The email address to validate
 * @returns A boolean indicating if the email is valid
 */
export const isValidEmail = (email: string): boolean => {
  const result = emailSchema.safeParse(email);
  return result.success;
};

// Define common email templates
export type EmailTemplate = 
  | 'welcome' 
  | 'reset-password'
  | 'verify-email'
  | 'subscription-confirmation'
  | 'payment-receipt'
  | 'post-generated'
  | 'monthly-usage';

// Define email data structure
export interface EmailData {
  to: string;
  subject: string;
  html?: string;
  text?: string;
  from?: string;
  cc?: string[];
  bcc?: string[];
  replyTo?: string;
  attachments?: Array<{
    filename: string;
    content: string | Buffer;
    contentType?: string;
  }>;
  // Additional fields for specific templates
  templateData?: {
    [key: string]: any;
  };
}

/**
 * Get default From email address
 */
export const getDefaultFromEmail = (): string => {
  return 'AISEOBlogGenerator <noreply@aiseobloggenerator.com>';
};

/**
 * Formats an email address with a name
 * @param email The email address
 * @param name The name to include
 * @returns Formatted email string "Name <email@example.com>"
 */
export const formatEmailWithName = (email: string, name: string): string => {
  return `${name} <${email}>`;
};